<template>
  <v-select
    :value="value"
    :items="items"
    prepend-icon="history"
    label="History"
    @input="onInput"
  ></v-select>
</template>

<script>
export default {
  props: {
    value: String
  },
  data() {
    return {
      items: [
        { value: "30", text: "30 days" },
        { value: "90", text: "3 months" },
        { value: "180", text: "6 months" },
        { value: "360", text: "1 year" }
      ]
    };
  },
  methods: {
    onInput(value) {
      this.$emit("input", value);
    }
  }
};
</script>
